import React from 'react';
import { Flex, VStack, Button, Text } from '@cad-arc';
import { DispatchAreaGroupObject } from '@mark43/cad-api';
import { DispatchAreaManagementForm } from './types';
import { useIntegratedForm } from '../../forms/use-integrated-form';

export function QuickGrabSection(props: {
    dispatchAreaGroupObjects?: DispatchAreaGroupObject[];
}): React.ReactElement {
    const integratedForm = useIntegratedForm<DispatchAreaManagementForm>();
    const allValues = integratedForm.form.watch();
    return props.dispatchAreaGroupObjects?.length ? (
        <VStack alignItems="start">
            <Text variant="headingXs">Quick Grab</Text>
            <Flex flexWrap="wrap" style={{ rowGap: '5px' }}>
                {props.dispatchAreaGroupObjects.map((dispatchAreaGroupView) => {
                    const notFullyOwned = dispatchAreaGroupView.dispatchAreaObjects.some(
                        (dispatchAreaObject) => {
                            return allValues[dispatchAreaObject.id] !== 'OWNER';
                        }
                    );
                    return (
                        <Button
                            key={dispatchAreaGroupView.id}
                            data-testid="quick-grab-button"
                            data-button-variant={notFullyOwned ? 'outline' : 'solid'}
                            data-button-text={dispatchAreaGroupView.name}
                            variant={notFullyOwned ? 'outline' : 'solid'}
                            style={{ marginRight: '5px' }}
                            onClick={() => {
                                if (notFullyOwned) {
                                    dispatchAreaGroupView.dispatchAreaObjects.forEach(
                                        (dispatchAreaObject) => {
                                            integratedForm.form.setValue(
                                                dispatchAreaObject.id.toString(),
                                                'OWNER'
                                            );
                                        }
                                    );
                                } else {
                                    dispatchAreaGroupView.dispatchAreaObjects.forEach(
                                        (dispatchAreaObject) => {
                                            integratedForm.form.setValue(
                                                dispatchAreaObject.id.toString(),
                                                'NONE'
                                            );
                                        }
                                    );
                                }
                            }}
                            {...integratedForm.getGenericButtonProps()}
                        >
                            {dispatchAreaGroupView.name}
                        </Button>
                    );
                })}
            </Flex>
        </VStack>
    ) : (
        <></>
    );
}
